import { fn } from '@ember/helper';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import type { InfolayerItem } from 'webapp/services/infolayer';

export default class InfolayersComponent extends Component {
	@service declare infolayer: Service.Infolayer;

	get layers(): InfolayerItem[] {
		return this.infolayer.items;
	}

	@action
	close(layer: InfolayerItem): void {
		if (!layer.preventClose) {
			layer.close();
		}
	}
	<template>
		<div id="infolayers">
			{{#each this.layers as |layer|}}
				{{#let (component layer.componentClass) as |ComponentName|}}
					<ComponentName @model={{layer}} @onClose={{fn this.close layer}} />
				{{/let}}
			{{/each}}
		</div>
	</template>
}
